"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetServices = exports.useFilterServices = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var hooks_2 = require("utils/hooks");
var useInfiniteScroll_1 = __importDefault(require("utils/hooks/useInfiniteScroll"));
var ordered_1 = require("utils/selectors/ordered");
var useFilterServices = function (servicesList, searchText) { return react_1.default.useMemo(function () { return !searchText
    ? servicesList
    : servicesList === null || servicesList === void 0 ? void 0 : servicesList.filter(function (item) {
        var fields = [item.name, item.niceName, item.id];
        return fields.some(function (fieldVal) { var _a; return (_a = fieldVal === null || fieldVal === void 0 ? void 0 : fieldVal.toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes(searchText.toLocaleLowerCase()); });
    }); }, [searchText, servicesList]); };
exports.useFilterServices = useFilterServices;
var useGetServices = function (extractors) {
    var TOOLS_PER_PAGE = 100;
    // const [searchText, setSearchText, searchTextDebounced] = useDebouncedSetSearch();
    var _a = __read((0, hooks_2.useSearch)(), 2), searchText = _a[0], setSearchText = _a[1];
    var _b = __read((0, hooks_2.useSearch)('sId'), 2), selectedServiceId = _b[0], setSelectedServiceId = _b[1];
    var servicesArray = (0, react_redux_1.useSelector)(ordered_1.selectServices);
    var filteredServices = (0, exports.useFilterServices)(servicesArray, searchText);
    var selectedService = react_1.default.useMemo(function () { return selectedServiceId ? filteredServices === null || filteredServices === void 0 ? void 0 : filteredServices.find(function (_a) {
        var id = _a.id;
        return id === selectedServiceId;
    }) : undefined; }, [selectedServiceId, servicesArray]);
    var sortedServices = (0, hooks_1.useSortArray)(filteredServices, extractors);
    var _c = __read((0, useInfiniteScroll_1.default)(sortedServices || [], TOOLS_PER_PAGE), 2), servicesList = _c[0], loaderRef = _c[1];
    return [sortedServices, servicesList, selectedService, setSelectedServiceId, searchText, setSearchText, loaderRef];
};
exports.useGetServices = useGetServices;
